import React, { useState } from "react";
import { Button, Skeleton } from "antd";
import { useGetFavouriteContactsQuery } from "../../../redux/services/api";
import "./index.scss";

interface FavouritesProps {
  handleClick: (favourite: any) => void;
}

const Favourites: React.FC<FavouritesProps> = ({ handleClick }) => {
  const { data, isLoading } = useGetFavouriteContactsQuery();
  const [expanded, setExpanded] = useState(false);

  const contacts = data?.favouriteContacts || [];
  const visibleContacts = expanded ? contacts : contacts.slice(0, 5);

  return (
    <div className={`favourites ${expanded ? "expanded" : ""}`}>
      {isLoading ? (
        Array.from([1, 2, 3, 4, 5, 6]).map((fav, index) => (
          <Skeleton.Button
            key={index}
            active
            shape="circle"
            className="fav-btn-skeleton"
          />
        ))
      ) : visibleContacts.length > 0 ? (
        <>
          {visibleContacts.map((contact) => (
            <Button
              type="text"
              title={contact.fullName}
              key={contact._id}
              shape="circle"
              className="fav-btn"
              onClick={() => handleClick(contact)}
            >
              {contact.fullName?.[0] || "?"}
            </Button>
          ))}

          {!expanded && contacts.length > 6 && (
            <Button
              type="text"
              className="more-btn"
              shape="circle"
              onClick={() => setExpanded(true)}
            >
              <div>
                +{contacts.length - 5}
                <br />
                more
              </div>
            </Button>
          )}
        </>
      ) : null}
    </div>
  );
};

export default Favourites;
